/* eslint-disable no-debugger */
import { Injectable } from '@angular/core';
import axios from 'axios';
import { environment } from '@/environments/environment';
import { ToastService } from './script/toast.service';
import { RptsResponse } from '@/app/interfaces/accession';
import { LoaderService } from '@/app/services/interceptor/loader-service';

@Injectable({
  providedIn: 'root',
})
export class RptsService {
  private readonly apiUrl = '/api/aurora';

  constructor(
    private toastService: ToastService,
    private loader: LoaderService
  ) {}

  async getRpts(paramsTab): Promise<RptsResponse> {
    try {
      this.loader.show();

      const response = await axios.post<RptsResponse>(
        `${environment.url}${this.apiUrl}/listado`,
        { filters: { params: paramsTab }, list: 'rpts' },
        {
          withCredentials: true,
        }
      );
      return response.data;
    } catch (error) {
      this.toastService.showError('Error al obtener los Rpts', error?.message || 'Ha ocurrido un error inesperado');
      throw error;
    } finally {
      this.loader.hide();
    }
  }

  async updateRpts(params): Promise<unknown> {
    try {
      this.loader.show();
      const response = await axios.post<RptsResponse>(
        `${environment.url}${this.apiUrl}/rpts_adhesion`,
        { params: params },
        {
          withCredentials: true,
        }
      );
      return response.data;
    } catch (error) {
      this.toastService.showError('Error al actualizar los rpts', error?.message || 'Ha ocurrido un error inesperado');
      throw error;
    } finally {
      this.loader.hide();
    }
  }
}
